import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelecionarCliente from "../DialogContentSelecionarCliente/indext";
import {
  clienteDefValue,
  IDataPublicos,
} from "../../types/api/geral/pesquisar-publicos";

export default function SelectPublico({
  value,
  label = "Público",
  required = false,
  error = false,
  errorMessage = undefined,
  defaultFiltroTipoClient = [],
  extraParams = {},
  onChange,
  showAllTypes = false
}: SelectSimpleApiQueryProps & { showAllTypes?: boolean }) {
  const [openModal, setOpenModal] = useState(false);

  const handleClose = () => setOpenModal(false);

  const inputLabel = value
    ? `${value.tipo_publico}${value.codigo_publico} - ${value.nome_pessoa}`
    : "";

  return (
    <>
      <TextField
        {...{ required, error }}
        label={label}
        variant="outlined"
        fullWidth
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          input: { readOnly: true }
        }}
        value={inputLabel}
        helperText={error ? errorMessage : ""}
      />
      {
        openModal &&
        <Dialog
          fullWidth
          maxWidth="sm"
          open={openModal}
          onClose={handleClose}
        >
          <DialogContentSelecionarCliente
            {...{ handleClose, extraParams, label }}
            defaultFiltroTipoClient={defaultFiltroTipoClient}
            showAllTypes={showAllTypes}
            defaultValue={value || clienteDefValue}
            onChange={(value) => {
              onChange(value as IDataPublicos)
              handleClose()
            }}
          />
        </Dialog>

      }
    </>
  )
}

interface SelectSimpleApiQueryProps {
  label?: string
  value: IDataPublicos | null
  onChange: (arg: IDataPublicos | null) => void
  required?: boolean
  error?: boolean
  errorMessage?: string | undefined
  defaultFiltroTipoClient?: string[]
  extraParams?: { [key: string]: any };
}
